import { usePixelLoader } from '~/hooks/usePixelLoader';

interface PixelProps {
  pixelId: string;
  marketingCookies: boolean;
}

const AdSensePixel = ({ pixelId, marketingCookies }: PixelProps) => {
  usePixelLoader(() => {
    const trimmedId = pixelId?.trim();
    // match valid AdSense publisher id: ca-pub- followed by 16 digits
    if (!trimmedId?.match(/^ca-pub-\d{16}$/) || !marketingCookies) {
      return;
    }

    // Prevent duplicate script injection
    if (document.getElementById('adsense-pixel')) {
      return;
    }

    const script = document.createElement('script');
    script.id = 'adsense-pixel';
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${trimmedId}`;
    document.head.appendChild(script);

    return () => {
      try {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      } catch {
        // Script already removed, safe to ignore
      }
    };
  }, [pixelId, marketingCookies]);

  return null;
};

export default AdSensePixel;
